import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api/dto/benefit-dto';
import React from 'react';
import { Route } from 'react-router-dom';
import { RoutesExtensionInterface } from '../../../extension/interface/routes.extension.interface';
import { BikeleasingRoutes } from '../../../page/BenefitBikeleasingPage';
import PrivatePage from '../../auth/PrivatePage';

export class BikeleasingRoutesExtension extends RoutesExtensionInterface {
  get routes(): React.ReactNode {
    return (
      <Route
        path={`/${BenefitDTOBenefitEnum.Bikeleasing.toLowerCase()}/*`}
        element={<PrivatePage page={BikeleasingRoutes} benefit={BenefitDTOBenefitEnum.Bikeleasing} />}
      />
    );
  }
}
